<app-project-form
  [formData]="currentDraft!"
  (formSubmitted)="onProjectSubmit($event)"
  (submittedChange)="submittedValue = $event">
</app-project-form>
